module.exports = __webpack_public_path__ + "img/retired-2017-exhibition.9b990b9b.jpg";